import { render, staticRenderFns } from "./NowLoadingOverlayComponent.vue?vue&type=template&id=18fda31e"
import script from "./NowLoadingOverlayComponent.vue?vue&type=script&lang=js"
export * from "./NowLoadingOverlayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports